import { isFeatureEnabled } from 'owa-feature-flags';
import { GRIFFIN_ACTIONS_FEATURE } from '../../helpers/FeatureFlagName';

/** Returns true if cal-txp-griffin flag is on and false otherwise */
export default function isGriffinRequestSupported() {
    return isFeatureEnabled(GRIFFIN_ACTIONS_FEATURE);
}
